import { render, staticRenderFns } from "./FilterWrapper.vue?vue&type=template&id=3448e034"
import script from "./FilterWrapper.vue?vue&type=script&lang=js"
export * from "./FilterWrapper.vue?vue&type=script&lang=js"
import style0 from "./FilterWrapper.vue?vue&type=style&index=0&id=3448e034&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports